import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthProvider";

export function RequirePlatformRole({ children }: { children: ReactNode }) {
  const { isPlatformMember, loading } = useAuth();
  if (loading) return <div className="public-page">Validando acesso Yatta…</div>;
  if (!isPlatformMember) return <Navigate to="/" replace />;
  return <>{children}</>;
}
